import { css } from '@emotion/react';
import { Theme } from '../../../config/theme';

export default (theme: Theme) => ({
  base: css`
    z-index: 1;
    border: none;
    font-size: ${theme.fontSizes.small};
    min-width: 201px;
    height: 48px;
    letter-spacing: 0.1em;
    line-height: 1.81em;

    @media (max-width: 30em) {
      width: 100%;
    }
  `,
  default: css`
    color: ${theme.color.secondary};
    background: ${theme.color.button};
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    &:hover {
      filter: brightness(0.8);
    }
  `,
  dark: css`
    color: ${theme.color.primary};
    background: ${theme.color.secondary};
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `,
});
